import React from 'react';
import { Info } from 'lucide-react';
import { useBilling } from '../contexts/BillingContext';
import usePermissions from '../hooks/usePermissions';

const PlanBanner: React.FC = () => {
    const { billing } = useBilling();
    // Was an inline `wsIsOwner || user?.is_owner || user?.roles?.includes('admin')`.
    const { isAdminOrOwner } = usePermissions();

    if (!billing || billing.plan !== 'trial') return null;
    if (isAdminOrOwner) return null;

    return (
        <div className="bg-blue-50 dark:bg-blue-950/40 border-b border-blue-100 dark:border-blue-900/60 text-blue-900 dark:text-blue-200 px-4 py-2">
            <div className="max-w-7xl mx-auto flex items-center gap-2 text-sm">
                <Info className="w-4 h-4 flex-shrink-0" />
                <p className="leading-snug">
                    Your workspace is on the <span className="font-semibold">Free plan</span>. Contact your workspace owner to upgrade your workspace plan.
                </p>
            </div>
        </div>
    );
};

export default PlanBanner;
